// Fetch Population
export const GET_POPULATION = "GET_POPULATION";
export const GET_POPULATION_SUCCESS = "GET_POPULATION_SUCCESS";
export const GET_POPULATION_FAIL = "GET_POPULATION_FAIL";

// Add Population
export const ADD_POPULATION = "ADD_POPULATION";
export const ADD_POPULATION_SUCCESS = "ADD_POPULATION_SUCCESS";
export const ADD_POPULATION_FAIL = "ADD_POPULATION_FAIL";

// Update Population
export const UPDATE_POPULATION = "UPDATE_POPULATION";
export const UPDATE_POPULATION_SUCCESS = "UPDATE_POPULATION_SUCCESS";
export const UPDATE_POPULATION_FAIL = "UPDATE_POPULATION_FAIL";

// Delete Population
export const DELETE_POPULATION = "DELETE_POPULATION";
export const DELETE_POPULATION_SUCCESS = "DELETE_POPULATION_SUCCESS";
export const DELETE_POPULATION_FAIL = "DELETE_POPULATION_FAIL";

// Set Field-Level Errors
export const SET_POPULATION_FIELD_ERRORS = "SET_POPULATION_FIELD_ERRORS";
